// export const apiUri ="https://cbank.live";
export const apiUri ="https://www.cdrive.pro";
// export const apiUri = "http://localhost/public_html";
// export const apiUri = "http://localhost/ctbc";